import { motion } from 'framer-motion'
import { Button } from '@/components/ui/button-partners'

const diferenciais = [
  {
    title: 'Edição Profissional',
    description:
      'cada foto é ajustada manualmente para cores, brilho, contraste e nitidez, garantindo páginas vibrantes e harmoniosas.',
  },
  {
    title: 'Curadoria Especializada',
    description:
      'selecionamos as imagens que contam a história de forma fluida e emocionante, evitando repetições e destacando os momentos mais importantes.',
  },
  {
    title: 'Layout Exclusivo',
    description:
      'design estratégico e personalizado que transforma o álbum em uma narrativa visual única.',
  },
  {
    title: 'Aprovação antes da impressão',
    description:
      'você ou seu cliente revisa todo o álbum antes da produção, garantindo fidelidade total ao que foi imaginado.',
  },
  {
    title: 'Experiência confiável e segura',
    description:
      'cada etapa é feita para que você indique com tranquilidade, oferecendo aos seus clientes uma experiência impecável.',
  },
  {
    title: 'Qualidade Internacional',
    description:
      'utilizamos materiais e técnicas de impressão de alta qualidade, garantindo álbuns duráveis, acabamento premium e cores impecáveis, que valorizam cada foto e cada memória.',
  },
]

const PorQueEscolherSection = () => {
  return (
    <section
      id="por-que-escolher"
      className="w-full py-16 md:py-24 bg-background"
    >
      <div className="max-w-4xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-10"
        >
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-bold italic text-foreground leading-tight mb-4">
            Por que ser parceiro da FotoLivro Store?
          </h2>
          <p className="font-serif text-xl md:text-2xl text-foreground mb-4">
            Indique o melhor para o seu cliente com segurança e confiança
          </p>
          <p className="text-base text-muted-foreground font-body max-w-3xl mx-auto leading-relaxed mb-8">
            Quando você escolhe a FotoLivro Store, entrega mais do que álbuns:
            oferece experiências que encantam, valorizam seu trabalho e
            emocionam seus clientes. Cada álbum é feito com cuidado e expertise,
            garantindo resultado impecável e memorável.
          </p>
          <h3 className="font-sans text-lg md:text-xl font-semibold text-accent">
            O que faz a FotoLivro Store diferente:
          </h3>
        </motion.div>

        {/* Lista de Diferenciais com Bullet Points */}
        <motion.ul
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.1 }}
          className="space-y-4 mb-12 max-w-2xl mx-auto"
        >
          {diferenciais.map((item, index) => (
            <motion.li
              key={item.title}
              initial={{ opacity: 0, x: -10 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: index * 0.05 }}
              className="flex items-start gap-3"
            >
              <span className="text-secondary font-bold text-lg leading-relaxed">
                •
              </span>
              <p className="text-foreground font-body leading-relaxed">
                <span className="font-sans font-semibold">{item.title}:</span>{' '}
                <span className="text-muted-foreground">
                  {item.description}
                </span>
              </p>
            </motion.li>
          ))}
        </motion.ul>

        {/* CTA */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.3 }}
          className="text-center"
        >
          <Button variant="elegant" size="lg" className="px-8 py-6" asChild>
            <a href="#como-funciona">Quero ser parceiro</a>
          </Button>
        </motion.div>
      </div>
    </section>
  )
}

export default PorQueEscolherSection
